import 'a11y-toggle';
import 'plugins/externalLinks';
import 'modules/nav';
import 'modules/slideshow';

// Add "js" class to the html element
document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
